export enum FieldVisibility {
    All,
    Franchise,
    Division,
    Transaction
}
